import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";

export default function RekendeelTable(props) {
    const fhMinus1 = props.fhMinus1;
    const fhMinus2 = props.fhMinus2;
    const fhMinus3 = props.fhMinus3;
    const fhAvg = props.fhAvg;
    const saldibalans = props.saldibalans;
    const opgeteld = props.opgeteld;
    const betrokkene = props.betrokkene;
    const printSet = props.printSet

    const descriptions = {
        opbrengsten: "Opbrengsten",
        inkoopkosten: "Inkoopkosten",
        inhuur: "inhuur derden/uitbesteed werk",
        bedrijfkosten: "Totale overige bedrijfskosten",
        afscrijvigen: "afschrijvingen",
        batenenlasten: "Financiële baten en lasten",
        arbeidKosten: "kosten vervangende arbeid",
        winst: "Saldo winst- en verliesrekening",
        premie: "Premies AOV/pensioen/lijfrente",
        calculateRekendeel: false,
        zelfstandigenaftrek: "zelfstandigenaftrek",
        mkbVrijstelling: "mkb-vrijstelling",
        inkomenBox1: "belastbaar (Box 1) inkomen",
        totaalbox1aftrekposten: "Totaal box 1 aftrekposten",
        tariefsaanpassing: "Tariefsaanpassing",
        belasting: "Belasting & Premie Volksverz",
        heffingskorting: "Algemene heffingskorting",
        arbeidskorting: "Arbeidskorting",
        inkomenindehoogsteschaal: "Inkomen in de hoogste schaal",
        verschuldigdeInkostenBelasting: "Verschuldigde inkomstenbelasting",
        zvwBijdrage: "Inkomensafhankelijke bijdrage Zvw",
        nettoJaarInkomen: "Netto jaarinkomen",
        jaarNCI: "NCI per jaar",
        maandNCI: "NCI per maand",
        maandBruto: "Bruto per maand",
    }

    const reportColumns = {
        all: [
            { name: "opbrengsten", border: "none", weight: "normal", height: 20 },
            { name: "inkoopkosten", border: "none", weight: "normal", height: 20 },
            { name: "inhuur", border: "none", weight: "normal", height: 20 },
            { name: "bedrijfkosten", border: "none", weight: "normal", height: 20 },
            { name: "arbeidKosten", border: "none", weight: "normal", height: 20 },
            { name: "afscrijvigen", border: "none", weight: "normal", height: 20 },
            { name: "batenenlasten", border: "none", weight: "normal", height: 20 },
            { name: "winst", border: "double", weight: "bold", height: 20 },
            { name: "blank", border: "none", weight: "normal", height: 5 },
            { name: "zelfstandigenaftrek", border: "none", weight: "normal", height: 20 },
            { name: "mkbVrijstelling", border: "none", weight: "normal", height: 20 },
            { name: "inkomenindehoogsteschaal", border: "none", weight: "normal", height: 20 },
            { name: "totaalbox1aftrekposten", border: "none", weight: "normal", height: 20 },
            { name: "tariefsaanpassing", border: "none", weight: "normal", height: 20 },
            { name: "premie", border: "none", weight: "normal", height: 20 },
            { name: "inkomenBox1", border: "double", weight: "bold", height: 20 },
            { name: "blank", border: "none", weight: "normal", height: 5 },
            { name: "belasting", border: "none", weight: "normal", height: 20 },
            { name: "heffingskorting", border: "none", weight: "normal", height: 20 },
            { name: "arbeidskorting", border: "none", weight: "normal", height: 20 },
            { name: "verschuldigdeInkostenBelasting", border: "double", weight: "bold", height: 20 },
            { name: "zvwBijdrage", border: "none", weight: "normal", height: 20 },
            { name: "premie", border: "none", weight: "normal", height: 20 },
            { name: "nettoJaarInkomen", border: "double", weight: "bold", height: 20 },
            { name: "blank", border: "none", weight: "normal", height: 5 },
            { name: "jaarNCI", border: "none", weight: "normal", height: 20 },
            { name: "maandNCI", border: "none", weight: "normal", height: 20 },
            // { name: "maandBruto", border: "none", weight: "normal", height: 20 },
        ],
        p2: [
            { name: "jaarNCI", border: "none", weight: "normal", height: 20 },
            { name: "maandNCI", border: "none", weight: "normal", height: 20 },
            // { name: "maandBruto", border: "none", weight: "normal", height: 20 },
        ]
    }

    return (
        <div>
            <Table stickyHeader>
                <TableHead >
                    <TableRow>
                        <TableCell sx={{ width: 20, height: 20, paddingTop: 0.5, paddingBottom: 0.5 }}> </TableCell>
                        <TableCell sx={{ width: 20, height: 20, paddingTop: 0.5, paddingBottom: 0.5, backgroundColor: fhMinus3.dataChanged ? 'red' : 'white' }} align="right" >{betrokkene.jaarMinus3}</TableCell>
                        <TableCell sx={{ width: 20, height: 20, paddingTop: 0.5, paddingBottom: 0.5, backgroundColor: fhMinus2.dataChanged ? 'red' : 'white' }} align="right" >{betrokkene.jaarMinus2}</TableCell>
                        <TableCell sx={{ width: 20, height: 20, paddingTop: 0.5, paddingBottom: 0.5, backgroundColor: fhMinus1.dataChanged ? 'red' : 'white' }} align="right" >{betrokkene.jaarMinus1}</TableCell>
                        <TableCell sx={{ width: 20, height: 20, paddingTop: 0.5, paddingBottom: 0.5, backgroundColor: fhAvg.dataChanged ? 'red' : 'white' }} align="right" >Gemiddeld realisatie</TableCell>
                        <TableCell sx={{ width: 20, height: 20, paddingTop: 0.5, paddingBottom: 0.5, backgroundColor: opgeteld.dataChanged ? 'red' : 'white' }} align="right" >{betrokkene.jaar + " Mogelijke exploitatie"}</TableCell>
                        <TableCell sx={{ width: 20, height: 20, paddingTop: 0.5, paddingBottom: 0.5, backgroundColor: saldibalans.dataChanged ? 'red' : 'white' }} align="right" >{"Realisatie tot incident"}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {reportColumns[printSet].map((val) => (
                        <TableRow >
                            <TableCell sx={{ height: val.height, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: val.border, fontWeight: val.weight, alignItems: "end" }}>{descriptions[val.name]}</TableCell>
                            <TableCell sx={{ height: val.height, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: val.border, fontWeight: val.weight, alignItems: "end" }} align="right">{(val.name === "blank") ? "" : new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(fhMinus3[val.name])}</TableCell>
                            <TableCell sx={{ height: val.height, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: val.border, fontWeight: val.weight, alignItems: "end" }} align="right">{(val.name === "blank") ? "" : new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(fhMinus2[val.name])}</TableCell>
                            <TableCell sx={{ height: val.height, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: val.border, fontWeight: val.weight, alignItems: "end" }} align="right" >{(val.name === "blank") ? "" : new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(fhMinus1[val.name])}</TableCell>
                            <TableCell sx={{ height: val.height, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: val.border, fontWeight: val.weight, alignItems: "end" }} align="right">{(val.name === "blank") ? "" : new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(fhAvg[val.name])}</TableCell>
                            <TableCell sx={{ height: val.height, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: val.border, fontWeight: val.weight, alignItems: "end" }} align="right">{(val.name === "blank") ? "" : new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(opgeteld[val.name])}</TableCell>
                            <TableCell sx={{ height: val.height, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: val.border, fontWeight: val.weight, alignItems: "end" }} align="right">{(val.name === "blank") ? "" : new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(saldibalans[val.name])}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}